import React, { FC } from "react";
import {
  UI_ModuleTextDownCard,
  UI_ModuleTitleCard,
} from "../../../../../../UI_ITO/indexUI";

interface LegalEntityCardProps {
  inn: string;
  name: string;
  percent: number;
}

export const LegalEntityCard: FC<LegalEntityCardProps> = (props) => {
  const { inn, name, percent } = props;

  return (
    <div>
      <UI_ModuleTitleCard
        title={name}
        style={{ width: "100%" }}
        icon={<></>}
        textDown={
          <UI_ModuleTextDownCard
            textDown={[`ИНН ${inn}`, `Доля УК: ${percent}%`]}
          />
        }
      />
    </div>
  );
};
